import { useState } from "react";
import { tickerItems } from "@/mocks/stories";

const navLinks = [
  { label: "在追专题", href: "#topics" },
  { label: "热度飙升", href: "#heat" },
  { label: "发酵追踪", href: "#track" },
  { label: "最新进展", href: "#progress" },
  { label: "当事人回应", href: "#responses" },
  { label: "讨论区", href: "#community" },
];

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-40 border-b border-secondary-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          <div className="flex items-center gap-3">
            <a href="#top" className="group flex items-center gap-2.5">
              <span className="relative grid h-9 w-9 place-items-center bg-foreground-950 text-background-50">
                <span className="font-heading text-lg font-black leading-none">黑</span>
                <span className="absolute -right-1.5 -top-1.5 h-2.5 w-2.5 bg-primary-500" />
              </span>
              <span className="flex items-baseline gap-1.5">
                <span className="font-heading text-[26px] font-black leading-none tracking-tight text-foreground-950">
                  黑料
                </span>
                <span className="hidden whitespace-nowrap text-[11px] font-medium text-secondary-500 sm:inline">
                  八卦发酵追踪站
                </span>
              </span>
            </a>
            <span className="hidden h-5 w-px bg-secondary-300 xl:block" />
            <span className="hidden items-center gap-1.5 text-[11px] font-medium tracking-wide text-secondary-500 xl:flex">
              <i className="ri-archive-2-line text-sm" />
              第 2041 期 · 2026.09.05
            </span>
          </div>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2.5">
            <span className="hidden items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-semibold text-primary-700 xl:flex">
              <i className="ri-radio-line text-xs" />
              追踪中 37
            </span>
            <button
              type="button"
              aria-label="搜索"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-search-line text-base" />
            </button>
            <a
              href="#community"
              className="hidden whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-megaphone-line text-sm" />
              爆料投稿
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-200 text-foreground-700 lg:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-secondary-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            <div className="flex flex-col">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between border-b border-secondary-100 py-3 text-sm font-medium text-foreground-800 last:border-0"
                >
                  {l.label}
                  <i className="ri-arrow-right-line text-secondary-400" />
                </a>
              ))}
            </div>
          </nav>
        )}
      </header>

      <div className="relative overflow-hidden border-b border-foreground-900 bg-foreground-950 text-background-100">
        <div className="mx-auto flex w-full max-w-[1240px] items-stretch">
          <span className="flex shrink-0 items-center gap-1.5 bg-primary-600 px-3 text-xs font-bold tracking-wide text-background-50">
            <i className="ri-flashlight-fill text-sm" />
            突发
          </span>
          <div className="relative flex-1 overflow-hidden py-2.5">
            <div className="ticker-track flex w-max whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((it, i) => (
                <span key={i} className="inline-flex items-center text-sm text-background-100/90">
                  <span className="px-3 text-primary-400">◆</span>
                  <span className="font-medium">{it.text}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}